import { configureStore } from "@reduxjs/toolkit";
import customerReducer from "../reducers/customers"
import collectionReducer from "../reducers/collections";
import assetReducer from "../reducers/assets";
import stateReducer from "../reducers/states";
import assetTypeReducer from "../reducers/asset_types";
import authReducer from "../reducers/auth";
import makeReducer from "../reducers/makes";
import modelReducer from "../reducers/models";
import userReducer from "../reducers/users";

export default configureStore({
    reducer: {
        customers: customerReducer,
        collections: collectionReducer,
        assets: assetReducer,
        states: stateReducer,
        assetTypes: assetTypeReducer,
        auth: authReducer,
        makes: makeReducer,
        models: modelReducer,
        users: userReducer,
    }
})
